import axiosClient from ".";
class FreezeAssers {
  static freeze_user_assets(id, data) {
    return axiosClient.put(`/super_admin/api/users/${id}`, data);
  }
}
export default FreezeAssers;
